// extracted by mini-css-extract-plugin
export default {"wrapper":"QuickStart_wrapper__PNI6s","title":"QuickStart_title__qkiFI","cards":"QuickStart_cards__H4JoO"};